export default __webpack_public_path__ + "static/media/Finideas-New-Logo.7074e47d.png";